import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const CITIES = [
    "Auckland",
    "Wellington",
    "Christchurch",
    "Queenstown",
    "Hamilton",
    "Tauranga",
    "Palmerston North",
    "Dunedin",
    "Whangarei",
    "Ashburton",
    "Timaru",
    "Gisborne",
    "Oamaru",
    "Greymouth",
];

export const TREATMENT_AREAS = [
    "Double chin",
    "Abdomen",
    "Flanks",
    "Arms",
    "Thighs",
    "Bra fat",
    "Knees",
    "Back rolls",
];

export const CONTACT = {
    email: "info@dermalis.co.nz",
    brand: "Aqualyx New Zealand",
    instagram: "https://www.instagram.com/aqualyx_nz/",
};

export const LOGO_URL = "https://customer-assets.emergentagent.com/job_aqualyx-nz/artifacts/vy9h2iyv_AqualyxLogo.png";
